import Cookies from 'js-cookie';

let storage;


try {
  window.localStorage.setItem('test', 'test');
  storage = window.localStorage;
} catch (error) {
  // Use cookies for Safari 12
  storage = {
    getItem: key => Cookies.get(key),
    // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
    setItem: (key, value) =>
      Cookies.set(key, value, {
        expires: 356,
        secure: process.env.NODE_ENV !== 'development',
      }),
    removeItem: key => Cookies.remove(key),
  };
}

export default storage;
